<script setup lang="ts">
const emit = defineEmits(['apply-filter', 'clear-all-filter'])
</script>

<template>
  <v-card width="400" max-height="300" flat>
    <v-card-text class="d-flex flex-column align-center justify-center">
      <v-icon color="primary" size="30" class="mb-4">mdi-information</v-icon>
      <div class="text-center" style="size: 16px">
        This feature will become available in the next version
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
